module.exports = __webpack_public_path__ + "assets/GTAmerica-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Bold.woff2
// module id = 997
// module chunks = 19